import flatpickr from '@nodeModules/flatpickr';

// we need to import all languages as they are used in locale: window.entrioLang - it wont work if language is not imported here
import { Croatian } from "@nodeModules/flatpickr/dist/l10n/hr.js";
import { Slovenian } from "@nodeModules/flatpickr/dist/l10n/sl.js";
import { Italian } from "@nodeModules/flatpickr/dist/l10n/it.js";
import { Bosnian } from "@nodeModules/flatpickr/dist/l10n/bs.js";
import { German } from "@nodeModules/flatpickr/dist/l10n/de.js";
import { english } from "@nodeModules/flatpickr/dist/l10n/default.js";
import { debounce } from '@nodeModules/throttle-debounce';

let selectedDate = '';

window.getEventTimes = function(data, fromAngular = false) {
	$.ajax({
		type: "POST",
		url: siteUrl + 'ajax/get_event_times',
		data: data,
	}).done(function (res) {
		const response = JSON.parse(res);

		if (document.querySelector('.time-event__events-wrap--first-loaded')) {
			document.querySelector('.time-event__events-wrap--first-loaded').remove();
		}

		selectedDate = data.dateStr;

	    var $scope = angular.element('[ng-controller=ticketsListController]').scope();
	    $scope.$apply(function() {
	    	$scope.ticketCategories = {};
	        $scope.timeEventsTemplate = response.html;

	        if (fromAngular) {
	        	$scope.loadTicketsAjax(data.eventTimeId, false)

	        	const $dateEl = document.querySelector(`[data-event-time-id='${data.eventTimeId}']`);
	        	if (!$dateEl.parentElement.classList.contains('selected')) {
	        		$dateEl.parentElement.classList.add('selected');
	        	}
	        }
	    });
	}).fail(function (error) {
		throw error;
	});
}

export const initPageJs = () => {
    document.querySelector('html').classList.add('event-page');
	document.querySelector('body').classList.add('event-page');

	const $eventSingleEl = document.querySelector('.event-single');
    if ($eventSingleEl && $eventSingleEl?.dataset?.backgroundImage) {
    	const style = document.createElement('style');
		style.textContent = `
			.event-single::before {
				background-image: url('${$eventSingleEl.dataset.backgroundImage}') !important;
			}
		`;
		document.head.appendChild(style);
    }

	let enabledDates = [];
	const $calendarEl = document.querySelector('.js-calendar');

	function enumerateDaysBetweenDates (startDate, endDate) {
  		let enumeratedDates = [];

  		while(moment(startDate) <= moment(endDate)){
    		enumeratedDates.push(startDate);
    		startDate = moment(startDate).add(1, 'days').format("YYYY-MM-DD");
  		}
  		return enumeratedDates;
	}

	if ($calendarEl) {
		etDates.forEach(date => {
			enabledDates = [...enabledDates, ...enumerateDaysBetweenDates(date.start, date.end)];
		})

		flatpickr($calendarEl, {
			inline: true,
			defaultDate: null,
			locale: window.entrioLang,
			enable: [...new Set(enabledDates)],
		    onChange: function(selectedDates, dateStr, instance, dayElem) {
		    	if (selectedDate !== dateStr) {
		    		selectedDate = dateStr

					let eventTimeId = false;
					let eventId = false;

					instance.calendarContainer.querySelectorAll('.flatpickr-day.selected .flatpickr-event').forEach(function(event) {
						eventTimeId = event.dataset.eventTimeId;
						eventId = event.dataset.eventId;
					});

					if (!eventTimeId) {
						return false;
					}

					const inputData = {
						eventTimeId: eventTimeId,
						eventId: eventId,
						appType: globalAppType,
						dateStr: dateStr,
					};

					window.getEventTimes(inputData);
				}
			},
			onDayCreate: function(dObj, dStr, fp, dayElem) {
				const date = dayElem.dateObj;
				const formattedDate = moment(date).format('YYYY-MM-DD');

				function markDate(value) {
					const fromDate = moment(value.start, 'YYYY-MM-DD');
					const toDate = moment(value.end, 'YYYY-MM-DD');

					if (moment(formattedDate).isSameOrAfter(fromDate) && moment(formattedDate).isSameOrBefore(toDate)) {
						dayElem.innerHTML += "<span data-event-id='" + value.event_id + "' data-event-time-id='" + value.et_id + "' class='flatpickr-event'></span>";
					}
				}

				etDates.forEach(markDate);
			}
		});
	}

	function setToggleDescriptionListener (elements) {
  		elements.forEach((element) => {
    		element.addEventListener('click', event => {
    			const parentRow = event.target.closest('.event-tickets__table-row');
    			const descriptionRow = parentRow.nextElementSibling;

				if (descriptionRow.classList.contains('is-shown')) {
					parentRow.classList.remove('is-active');
					element.classList.remove('is-active');
					descriptionRow.classList.remove('is-shown');
				} else {
					parentRow.classList.add('is-active');
					element.classList.add('is-active');
					descriptionRow.classList.add('is-shown');
				}
    		})
		});
	}

	const $toggleDescriptionRows = document.querySelectorAll('.js-toggle-description-row');

	if ($toggleDescriptionRows.length) {
		setToggleDescriptionListener($toggleDescriptionRows);
    };

    const $eventTicketsWrap = document.querySelector('.event-tickets__table-wrap');

    if ($eventTicketsWrap) {
	    new MutationObserver(function(mutationsList, observer) {
		    for(const mutation of mutationsList) {
		        if (mutation.type === 'childList' && mutation.addedNodes.length) {
		        	mutation.addedNodes.forEach(node => {
		        		if (node?.classList?.contains('event-tickets__table-row')) {
		        			let $addedToggleDescriptionRows = [];
		        			$addedToggleDescriptionRows = [...node?.querySelectorAll('.js-toggle-description-row')]

				            if ($addedToggleDescriptionRows.length) {
								setToggleDescriptionListener($addedToggleDescriptionRows);
			    			};
		        		}
		        	})
		        }
		    }
		}).observe($eventTicketsWrap, {childList: true, subtree: true});
    }

    const matchMediaMedium = window.matchMedia(`screen and (min-width: 768px)`);
    const $eventTicketsAction = document.querySelector('.js-event-tickets-action');

    if ($eventTicketsAction) {
    	if (matchMediaMedium.matches) {
	    	const $checkoutColumn =  document.querySelector('.event-tickets__checkout-column');

	    	if ($checkoutColumn) {
	    		$eventTicketsAction.style.maxWidth = `${$checkoutColumn.clientWidth}px`;
	    	} else {
	    		const columnPriceWidth =  document.querySelector('.event-tickets__column-price')?.clientWidth;
	    		const columnAmountWidth =  document.querySelector('.event-tickets__column-amount')?.clientWidth;

	    		$eventTicketsAction.style.maxWidth = `${columnPriceWidth ?? 0 + columnAmountWidth ?? 0}px`;
	    	}
	    }

    	window.setActionWidth = function() {
	    	if (matchMediaMedium.matches) {
	    		const $checkoutColumn =  document.querySelector('.event-tickets__checkout-column');

	    		if ($checkoutColumn) {
	    			$eventTicketsAction.style.maxWidth = `${$checkoutColumn.clientWidth}px`;
	    		} else {
	    			const columnPriceWidth =  document.querySelector('.event-tickets__column-price')?.clientWidth;
		    		const columnAmountWidth =  document.querySelector('.event-tickets__column-amount')?.clientWidth;

		    		$eventTicketsAction.style.maxWidth = `${columnPriceWidth ?? 0 + columnAmountWidth ?? 0}px`;
	    		}
	    	} else {
	    		$eventTicketsAction.style.maxWidth = '100%';
	    	}
	    };

	    const debouncedSetActionWidth = debounce(300, window.setActionWidth);

	    window.addEventListener('resize', debouncedSetActionWidth);
    }

    if (document.querySelectorAll('.js-track-view-item').length) {
	    document.querySelectorAll('.js-track-view-item').forEach(el => {
			window.track.trackViewItem(el);
		})
	}

	if (document.querySelectorAll('.js-track-select-item').length) {
		window.track.trackViewItemList(document.querySelector('.js-track-view-item-list'));

		document.querySelectorAll('.js-track-select-item').forEach(el => {
	  		el.addEventListener('click', event => {
	  			event.preventDefault();
	  			window.track.trackSelectItem(event.currentTarget.dataset)
	  		})
		})
	}
};
